import 'orgchart/dist/css/jquery.orgchart.css';
import 'orgchart';
import './orgchart.css';
import $ from 'jquery';
import ReactDOM from 'react-dom/client';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
import NtxOffcanvas from '@components/Offcanvas/NtxOffcanvas';
import OrgDetails from './OrgDetails';

const ShowStructure2 = ({ Hierarchy }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [departmentData, setDepartmentData] = useState(null);
  const chartContainerRef = useRef(null);
  const [zoomLevel, setZoomLevel] = useState(1); 

  useEffect(() => {
    if (!Hierarchy || !chartContainerRef.current) return;

    const $chartContainer = $(chartContainerRef.current);
    $chartContainer.empty();

    try {
      $chartContainer.orgchart({
        data: Hierarchy,
        pan: true,
        // zoom: true, // تفعيل التكبير والتصغير
        // zoomoutLimit: 0.5, // الحد الأدنى للتصغير
        // zoominLimit: 2, // الحد الأقصى للتكبير

        // nodeTemplate: data => {
        //   const nodeContainer = document.createElement('div');
        //   ReactDOM.createRoot(nodeContainer).render(<OrgNode data={data} />);
        //   return nodeContainer;
        // }

        nodeTemplate: function (data) {
          return ` 
    <div class="border border-1 d-flex flex-column justify-content-between" 
      
      style="height: 130px; width: 175px; text-align: center; cursor: pointer;">
      
      <div class="card-header bg-theme bg-opacity-25 d-flex justify-content-between p-1">
        <div class="dropdown">
          <a class="text-inverse text-opacity-50" data-bs-toggle="dropdown" style="cursor: pointer;">
            <i class="fa fa-ellipsis-h fs-5 text-theme"></i>
          </a>
          <ul class="dropdown-menu dropdown-menu-start">
            <a class="dropdown-item text-start edit-node" data-id="${data.id}" href="#">
              ${t('Details')} <i class="fa fa-user fa-fw me-2 text-theme"></i>
            </a>
          </ul>
        </div>
        <div class="d-flex justify-content-center align-items-center fw-bold h6 m-0" style="font-size: 10px;">
          ${data.name}
        </div>
      </div>

      <div class="click-node  d-flex align-items-center justify-content-center flex-grow-1" data-node='${JSON.stringify(data).replace(/'/g, '&apos;').replace(/"/g, '&quot;')}' >
        <i class="${data.iconStyle.icon} fs-1 ${data.iconStyle.color}"></i>
      </div>

      <div class='fw-normal h6 m-0' style="font-size: 9px;">
        ${data.childrenCount === 0 ? 'No subdepartments' : `${data.childrenCount} departments`}
      </div>

    </div>
  `;
        }
      });

      // إضافة حدث واحد فقط عند تحميل المخطط
      const handleClickNode = e => {
        e.preventDefault();
        const nodeData = JSON.parse(
          $(e.target)
            .closest('.click-node')
            .attr('data-node')
            .replace(/&quot;/g, '"')
            .replace(/&apos;/g, "'")
        );
        setDepartmentData(nodeData);
        setShow(true);
      };

      // استخدم event delegation بشكل فعال
      $chartContainer.on('click', '.click-node', handleClickNode);

      return () => {
        // إزالة الحدث عند التفكيك (cleanup)
        $chartContainer.off('click', '.click-node', handleClickNode);
      };
    } catch (error) {
      console.error('Error initializing orgchart:', error);
    }
  }, [Hierarchy]);

  // التحكم في التكبير والتصغير
  const handleZoomIn = () => setZoomLevel(prev => Math.min(prev + 0.1, 2)); // حد أقصى 2
  const handleZoomOut = () => setZoomLevel(prev => Math.max(prev - 0.1, 0.5)); // حد أدنى 0.5

  return (
    <>
      <div className='text-center'>
        <div
          className='org'
          dir='ltr'
          ref={chartContainerRef}
          // style={{ overflow: 'visible' }}
          style={{ transform: `scale(${zoomLevel})` }} // تطبيق تأثير التكبير
        ></div>
      </div>

 
      <NtxOffcanvas
        show={show}
        placement='end'
        showHeader={false}
        handleClose={() => setShow(false)}
        width='30%'
      >
        <OrgDetails data={departmentData} onClose={() => setShow(false)} />
      </NtxOffcanvas>
    </>
  );
};

export default ShowStructure2;

const OrgNode = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div
      className='click-node departmentData'
      data-node={JSON.stringify(data)}
      style={{ cursor: 'pointer' }}
    >
      <Card className='shadow border-theme' style={{ width: '180px', height: '130px' }}>
        <CardHeader className='fw-bold small bg-theme bg-opacity-25 d-flex justify-content-between'>
          <div className='dropdown'>
            <a
              className='text-inverse text-opacity-50'
              data-bs-toggle='dropdown'
              style={{ cursor: 'pointer' }}
            >
              <i className='fa fa-ellipsis-h text-theme'></i>
            </a>
            <ul className='dropdown-menu dropdown-menu-start'>
              <a className='dropdown-item text-start edit-node' data-id={data.id} href='#'>
                {t('Details')} <i className='fa fa-user fa-fw me-2 text-theme'></i>
              </a>
            </ul>
          </div>
          <div className='fw-bold'>{data.name}</div>
        </CardHeader>
        <CardBody className='d-flex align-items-center justify-content-center p-2 position-relative'>
          <i className={`${data.iconStyle.icon} fs-1 ${data.iconStyle.color}`} />
        </CardBody>
        <CardFooter className='p-1' style={{ fontSize: '10px' }}>
          {data.childrenCount === 0 ? 'No subdepartments' : `${data.childrenCount} departments`}
        </CardFooter>
      </Card>
    </div>
  );
};
